import { render, staticRenderFns } from "./FormProfileSenha.vue?vue&type=template&id=47df10af"
import script from "./FormProfileSenha.vue?vue&type=script&lang=js"
export * from "./FormProfileSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports